/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Role_Data_AnalyticsInputs */



/**
* | output |
* | --- |
* | "Data Analytics and BI" |
*
* @param {Team_Role_Data_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_role_data_analytics = /** @type {((inputs?: Team_Role_Data_AnalyticsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Role_Data_AnalyticsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("数据分析与商业智能")
	return /** @type {LocalizedString} */ ("Data Analytics and BI")
});